var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MlInput',{attrs:{"placeholder":_vm.$t(_vm.placeholder),"value":_vm.comma(_vm.inputValue),"readonly":_vm.readonly,"max":15,"noneCount":","},on:{"input":(value) => {
      _vm.inputValue = _vm.removeComma(value);
    },"keyup":(value) => _vm.$emit('keyup', value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }